module.exports = "<meta charset=\"utf-8\" />\n<router-outlet></router-outlet>\n"